/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1BannerBanneridLangsMutationRequest,
  PostApiV1BannerBanneridLangsMutationResponse,
  PostApiV1BannerBanneridLangsPathParams,
  PostApiV1BannerBanneridLangs400,
  PostApiV1BannerBanneridLangs401,
  PostApiV1BannerBanneridLangs404,
  PostApiV1BannerBanneridLangs500,
} from "../../types/bannerIdiomasController/PostApiV1BannerBanneridLangs.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPostApiV1BannerBanneridLangsUrl(
  bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/banner/${bannerId}/langs` as const,
  };
  return res;
}

/**
 * @description Cria uma nova tradução (idioma) para o banner (multipart/form-data). **(Requer Authorization para autenticação)**
 * @summary Criar idioma do banner (Requer Authorization para autenticação)
 * {@link /api/v1/banner/:bannerId/langs}
 */
export async function postApiV1BannerBanneridLangs(
  bannerId: PostApiV1BannerBanneridLangsPathParams["bannerId"],
  data?: PostApiV1BannerBanneridLangsMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1BannerBanneridLangsMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiV1BannerBanneridLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1BannerBanneridLangs400
      | PostApiV1BannerBanneridLangs401
      | PostApiV1BannerBanneridLangs404
      | PostApiV1BannerBanneridLangs500
    >,
    PostApiV1BannerBanneridLangsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1BannerBanneridLangsUrl(bannerId).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
